<style lang="stylus">
    .navigationfont
        position relative
        width 100%
        height 100%
        user-select none
        display: flex;
        align-items: center;

        .font-selecter
            float left
            position relative
            width 120px
            height 24px
            box-sizing border-box
            margin-right 12px
            border: 1px solid $box-bordercolor;
            border-radius: 4px;
            color: var(--text-color-primary);
            &:hover{
                background-color: $main-hovercolor;
                border-color $main-hovercolor
            }
            .font-name
                margin: 0
                text-indent 8px
                width 100%
                // padding-right 12px
                height 24px
                display block
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
                line-height 22px
                cursor pointer
                background-color: transparent;
            .inputBox
                outline none
                border none
                height 22px
                width 46px
                cursor auto
                -moz-appearance textfield
            input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
                -webkit-appearance none
                appearance none
                margin 0
            input:disabled
                background unset
                border unset
            .inputBox-arrow
                position absolute
                right 0
                top 0
                height 100%
                width 16px
                user-select none
                cursor pointer

            .font-list
                margin-top: 2px
                padding: 6px
                background-color var(--bg-color-tertiary)
                box-shadow $box-shadow
                height 400px
                overflow auto
                border-radius: $box-radius;
                li
                    list-style none
                    padding 5px 4px
                    margin-bottom 2px
                    user-select none
                    cursor pointer
                    border-radius: $box-radius;
                    &:hover
                        background-color $common-hover-color
                    &.active
                        background-color var(--bg-color-font-list-active)
            .down-arrow
                position absolute
                top: 50%;
                right: 8px
                transform: translate(0, -50%);
                width 8px
                height 4.24px
                cursor pointer
                color var(--svg-color-primary)
        .navigation-ban-btn .font-name,
        .navigation-ban-btn .down-arrow,
        .navigation-ban-btn .inputBox-arrow
            cursor not-allowed

        .expand-font-btn{
            width: 36px !important;
        }
        .font-btn
            float left
            position relative
            width 32px
            height 32px
            margin 0 4px
            user-select none
            position: relative;
            border-radius $common-border-radius
            &:not(.navigation-ban-btn)
                cursor pointer
            .item-arrow
                position absolute
                top: 15px;
                right: 0px;
                width 8px
                height 4.25px
                color var(--svg-color-primary)

            .item-icon-center
                pointer-events none;
                position: absolute;
                top: 50%;
                left 50%;
                transform: translate(-50%,-50%);
                width 24px
                height 24px
                color: var(--svg-color-primary);
            .item-icon-expand
                left 45%;
            .item-icon
                width 20px
                height 20px
                &.font-bg-icon
                    pointer-events none;
                    position: absolute;
                    top: 50%;
                    left 50%;
                    transform: translate(-50%,-50%);
                    color: var(--svg-color-gray-42);
            .item-color
                pointer-events none;
                position absolute
                bottom 7px
                margin-left 8px
                width 16px
                height 3px
                border-radius 1.5px

            .font-btn-arrow
                position absolute
                right 0
                bottom 0

            &:not(.font-btn-active):not(.activeFunc):not(.navigation-ban-btn):hover
                background-color $main-hovercolor

            .aroundbox-list
                width 167px
                height 180px
                padding 8px 10px
                background-color var(--bg-color-tertiary)
                border-radius 5px
                box-shadow $common-box-shadow
                box-sizing border-box
                z-index 1
                position absolute
                top 36px

                .aroundbox-li
                    float left
                    list-style none
                    width 33px
                    height 33px
                    box-sizing border-box
                    user-select none
                    cursor pointer
                    margin-right 5px

                    &:nth-child(4n)
                        margin-right 0

                    &:not(.ban-btn):hover
                        background-color $main-hovercolor

                    .item-icon
                        margin 3px
                        width 27px
                        height 27px
                        fill: var(--svg-color-navi-font-roundbox);
                        color: var(--svg-color-gray-42);
                        &.fontaround5, &.fontaround6
                            stroke:  var(--svg-color-gray-42);
                .roundbox-clean
                    float left
                    width 100%
                    height 24px
                    line-height 24px
                    margin-top 10px
                    border-top 1px solid var(--border-color-navi-font-roundbox)
                    user-select none
                    cursor pointer
                    &:not(.ban-btn)hover
                        background-color $main-hovercolor
                .ban-btn
                    opacity .2
                    cursor not-allowed

            .imgbox-list
                width 144px
                padding: 16px;
                background-color $navigation-modal-bgcolor
                border-radius 8px
                box-shadow $common-box-shadow
                box-sizing border-box
                z-index 1
                position absolute
                top 36px
                list-style none
                cursor: default;
                display grid;
                grid-template-columns repeat(3, 1fr)
                .dividing{
                  height: 1px;
                  background-color: $box-bordercolor;
                  margin: 4px 0;
                }
                .more-btn{
                  border-radius: $box-radius;
                  padding: 2px 7px;
                  cursor: pointer;
                  &:hover{
                    background-color $ft-hover
                  }
                }
                .align-line {
                    grid-column-start 1;
                    grid-column-end 4;
                    margin 12px 0;
                    border-top 1px solid var(--border-color-float-hv-line)
                }
                .imgbox-li
                    display: flex;
                    justify-content center;
                    align-items center;
                    list-style none
                    width 32px
                    height 32px
                    box-sizing border-box
                    user-select none
                    cursor pointer
                    margin-right 8px
                    position: relative;
                    border-radius: $box-radius;

                    &:nth-child(3n)
                        margin-right 0

                    &:not(.active):hover
                        background-color $main-hovercolor
                    &.active
                        background-color var(--bg-color-fontalgin-active-item)
                    .item-icon
                        width 24px
                        height 24px
                        color: var(--svg-color-gray-42)
                &.line-height-list
                    width 100px;
                    display block;
                    padding: 6px;
                    li
                        position relative
                        padding 6px 10px
                        padding-left 32px
                        user-select none
                        cursor pointer
                        width auto;
                        height auto
                        margin-right 0;
                        &:not(.active):hover
                            background-color $main-hovercolor
                        &.active
                            background-color $main-selectcolor
                        p
                            width 68px
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 16px;
                        &.active::before
                            line-height: 0;
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' %3E%3Cpath fill='%23424242' d='M5.94352 10.5293L3.70711 8.29291C3.31658 7.90239 2.68342 7.90239 2.29289 8.29291C1.90237 8.68344 1.90237 9.3166 2.29289 9.70712L5.29289 12.7071C5.70479 13.119 6.38016 13.0931 6.75926 12.6508L12.7593 5.65081C13.1187 5.23148 13.0701 4.60018 12.6508 4.24076C12.2315 3.88134 11.6002 3.9299 11.2407 4.34923L5.94352 10.5293Z'/%3E%3C/svg%3E");
                            position: absolute;
                            display: block;
                            left: 10px;
                            top: 6px;
                            width: 16px;
                            height: 16px;

                        &.hv-line
                            height 1px;
                            width calc(100% - 20px);
                            background-color var(--border-color-float-hv-line);
                            margin: 4px 0 4px 10px;
                            padding: 0;
                        &.more-setting
                            padding: 6px 0 6px 10px;
                            display inline-block
                            width 100%;

        .activeFunc
            background-color var(--themeActived)
        .font-btn-active
            background-color $main-selectcolor
        .size-change-btn
            border 1px solid var(--border-color-box-6)
            display flex
            cursor pointer
            &:hover
                background var(--bg-color-size-change-btn-hover)
        .size-change-btn.minus
            border-right 0px
            border-top-left-radius 4px
            border-bottom-left-radius 4px
            padding 10px 6px 10px 5px
            svg
                height  2px;
                width 11px
                color: var(--svg-color-primary);
        .size-change-btn.add
            border-left 0px
            border-top-right-radius 4px
            border-bottom-right-radius 4px
            padding 3px
            margin-right 4px
            svg
                height 16px;
                width 16px;
                color: var(--svg-color-primary);
        #sizeName
            margin-right 0
            border-radius 0
            text-align center
            .inputBox
                // max-width 60px
                // min-width 40px
                width 30px
                margin 0 8px
                text-indent 0px;


    .editor-content
        padding 15px
        padding-top 8px
        padding-bottom 5px;
        border-bottom-left-radius 4px;
        border-bottom-right-radius 4px;
        background-color var(--bg-color-tertiary);

        .active
                background-color var(--bg-color-selected) !important
        .activeFunc
            background-color var(--themeActived)
        .content-imgbox
            float left
            height 32px
            width 32px
            margin-right 10px
            position relative
            border-radius $common-border-radius
            .item-icon
                color: var(--svg-color-gray-42);
            &:not(.ban-btn):not(.activeFunc):hover
                background-color var(--hover-color-common-6)

            .item-icon
                position absolute
                top 50%
                left 50%
                transform translate(-50%,-50%)
                cursor pointer
                width 20px
                height 20px
            .item-color
                pointer-events none
                position absolute
                margin-left 7px
                bottom 5px
                border-radius 1.5px
                width 16px
                height 3px
            &.ban-btn
                opacity .2
                cursor not-allowed
                .item-icon
                    cursor not-allowed

            .liststylebox
                float left
                position relative
                width 100%
                height 100%

                .item-icon
                    width 24px
                    height 24px

                .liststylemodal
                    position absolute
                    width 174px
                    height 168px
                    padding 8px
                    background-color var(--bg-color-tertiary)
                    box-shadow $box-shadow
                    z-index 1

                    ul
                        border 1px solid var(--border-color-navi-text-setting-list-style)
                        padding 2px
                        width 158px
                        height 154px
                        list-style none

                        li
                            float left
                            width 48px
                            height 49px
                            padding 4px
                            margin-right 4px
                            position relative

                            &:hover
                                background-color $main-hovercolor
                            &.active
                                background-color $main-selectcolor
                            &:nth-child(3n)
                                margin-right unset

                            .item-icon
                                width 40px
                                height 41px

        .content-inputbox
            width 370px
            margin-top 24px
            padding-top 15px
            display flex
            flex-wrap wrap
            justify-content space-between

            .inputbox-line
                display flex

                .inputbox-title
                    float left
                    width 92px
                    text-align left
                    margin-right 5px
                    margin-bottom 10px
                    line-height 24px
                .iview_input
                    float left
                    width 69px
                    height 24px
                    .ivu-input-number-handler-wrap, .ivu-input-number-input
                        background-color var(--bg-color-tertiary)
    .navigation-ban-btn
        cursor not-allowed
        .item-icon-center, .font-box
            opacity .2
            filter grayscale(1)
        .item-color
            opacity .2
            filter grayscale(1)
        .Navigation-tips-box
            .item-clickmask
                cursor not-allowed !important
            >.item-icon-center, .font-box
                opacity .2
                filter grayscale(1)
</style>

<template>
    <div class="navigationfont">
        <div id="familyName" class="font-selecter">
            <p class="font-name" @click="clickFamilyName()">{{ activedFamily.replace(/\"/g, "") }}</p>
            <ul class="font-list" ref="fontList" v-show="showFamilyList">
                <li
                    v-for="(item, index) in family"
                    :key="index"
                    :style="{ fontFamily: item }"
                    :class="{ active: item == activedFamily }"
                    @mouseenter="startFamilyPreview(item)"
                    @mouseleave="endPreview"
                    @click="clickFamilyList(index)"
                >
                    {{ item }}
                </li>
            </ul>
            <iconSymbol class="down-arrow" :name="'downArrow'" @click.native="clickFamilyName()"></iconSymbol>
        </div>

        <div class="size-change-btn minus" @click="changeStepSize('-')">
            <iconSymbol name="font-minus" />
        </div>
        <div id="sizeName" class="font-selecter" style="width: unset">
            <div>
                <input
                    type="number"
                    class="font-name inputBox"
                    :style="{ width: '40px' }"
                    v-model="activedSize"
                    @focus="setOldSize($event)"
                    @blur="checkFontSize()"
                    @keyup.enter="iviewInputBlur($event)"
                />
                <ul class="font-list" ref="sizeList" v-show="showSizeList">
                    <li
                        v-for="(item, index) in size"
                        :key="index"
                        :class="{ active: item == activedSize }"
                        @mouseenter="startSizePreview(item - 0)"
                        @mouseleave="endPreview"
                        @click="clickSizeList(index)"
                    >
                        {{ item }}
                    </li>
                </ul>
                <div class="inputBox-arrow" @click="clickSizeName()">
                    <iconSymbol class="down-arrow" :name="'downArrow'"></iconSymbol>
                </div>
            </div>
        </div>
        <div class="size-change-btn add" @click="changeStepSize('+')">
            <iconSymbol name="font-add" />
        </div>

        <div
            class="font-btn"
            :class="{ 'font-btn-active': bold, activeFunc: activeFunc == 'tabsBold' }"
            :content="$t('tipsList.bold')"
            v-tippy="{ placement: 'bottom' }"
            @click.stop="clickBtn('bold')"
        >
            <iconSymbol class="item-icon-center" :name="'bold-large'"></iconSymbol>
        </div>
        <div
            class="font-btn"
            :class="{ 'font-btn-active': italic, activeFunc: activeFunc == 'tabsItaly' }"
            :content="$t('tipsList.italy')"
            v-tippy="{ placement: 'bottom' }"
            @click.stop="clickBtn('italy')"
        >
            <iconSymbol class="item-icon-center" :name="'italy-large'"></iconSymbol>
        </div>
        <div
            class="font-btn"
            :class="{ 'font-btn-active': underline, activeFunc: activeFunc == 'tabsUnderline' }"
            :content="$t('tipsList.underline')"
            v-tippy="{ placement: 'bottom' }"
            @click.stop="clickBtn('underline')"
        >
            <iconSymbol class="item-icon-center" :name="'underline-large'"></iconSymbol>
        </div>
        <div
            class="font-btn"
            :class="{ 'ban-btn': isTextPath, activeFunc: activeFunc == 'tabsFontBgColor' }"
            :content="$t('tipsList.bgColor')"
            v-tippy="{ placement: 'bottom' }"
            @click="showFontBackgoundColor($event)"
        >
            <iconSymbol
                :style="`pointer-events: none; fill:${fontBackGroundColor}`"
                :class="{ active: selectFontEditor == 1 }"
                class="item-icon-center font-bg-icon"
                :name="`new-backgroundcolor${isDarkTheme() ? '-dark' : ''}`"
            ></iconSymbol>
            <!-- <div class="item-color" :style="{ backgroundColor: fontBackGroundColor }"></div> -->
        </div>
        <div
            class="font-btn"
            :class="{ 'font-btn-active': fontColorWindow, activeFunc: activeFunc == 'tabsFontColor' }"
            :content="$t('tipsList.textColor')"
            v-tippy="{ placement: 'bottom' }"
            @click.stop="showFontColor($event)"
        >
            <iconSymbol
                class="item-icon-center"
                :style="`top: 48%; fill:${fontColor}`"
                :name="`new-fontcolorA${isDarkTheme() ? '-dark' : ''}`"
            ></iconSymbol>
            <!-- <div
                class="item-color"
                :style="{ backgroundColor: fontColor, border: fontColor === '#ffffff' ? '1px solid rgba(0,0,0,0.08)' : '' }"
            ></div> -->
            <!-- <iconSymbol class="item-color" :name="'FontColor'"></iconSymbol> -->
        </div>
        <!-- <div
            v-show="isNormalType"
            id="aroundmodal"
            class="font-btn"
            :class="{ 'font-btn-active': showFontAround, 'navigation-ban-btn': !(isTextPath || isText), activeFunc: activeFunc == 'tabsFontAround' }"
            @click="(isTextPath || isText) && showAroundModal()"
        >
            <div :content="$t('tipsList.textAround')" v-tippy="{ placement: 'bottom' }" style="height: 32px">
                <iconSymbol class="item-icon-center font-box" :name="'fontaround'"></iconSymbol>
            </div>
            <ul class="aroundbox-list" v-show="showFontAround">
                <li class="aroundbox-li" v-for="item in fontAroundList" :key="item.id" @click="clickAround(item.id)">
                    <iconSymbol class="item-icon" :name="item.name" :class="item.name"></iconSymbol>
                </li>
                <div
                    class="roundbox-clean"
                    :class="{ 'ban-btn': !isTextPath }"
                    @click="
                        () => {
                            !isTextPath ? '' : clickAround(15);
                        }
                    "
                >
                    {{ $t("cleanAround") }}
                </div>
            </ul>
        </div> -->
        <div
            id="alignmodal"
            class="font-btn expand-font-btn"
            :class="{ 'font-btn-active': showFontAlign, activeFunc: activeFunc == 'tabsFontAlign' }"
            @click="showAlignModal()"
        >
            <div :content="$t('tipsList.textAlign')" v-tippy="{ placement: 'bottom' }" style="height: 32px">
                <iconSymbol class="item-icon-center font-box item-icon-expand" :name="'centerleft'"></iconSymbol>
                <iconSymbol class="item-arrow" :name="'downArrow'"></iconSymbol>
            </div>
            <transition name="tabmodaltrans">
                <ul class="imgbox-list" v-show="showFontAlign">
                    <li
                        class="imgbox-li"
                        :class="{ active: item.id == fontAlignHActiveID }"
                        v-for="item in fontAlignHList"
                        :key="`${item.id}-h`"
                        @click.stop="clickAlign('h', item.id)"
                        @mouseenter="startPreviewAlign('h', item.id)"
                        @mouseleave="endPreview"
                        :content="$t(`tipsList.${item.name}`)"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                    </li>
                    <li class="align-line"></li>
                    <li
                        class="imgbox-li"
                        :class="{ active: item.id == fontAlignVActiveID }"
                        v-for="item in fontAlignVList"
                        :key="`${item.id}-v`"
                        @click.stop="clickAlign('v', item.id)"
                        @mouseenter="startPreviewAlign('v', item.id)"
                        @mouseleave="endPreview"
                        :content="$t(`tipsList.${item.name}`)"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                    </li>
                </ul>
            </transition>
        </div>
        <div
            id="lineheightmodal"
            class="font-btn expand-font-btn"
            :class="{ 'font-btn-active': showFontLineHeight, activeFunc: activeFunc == 'tabsFontLineHeight' }"
        >
            <div
                :content="$t('lineHeight')"
                v-tippy="{ placement: 'bottom' }"
                style="height: 32px"
                @click="showLineHeightModal()"
                v-click-outside="closeLineHeightModal"
            >
                <iconSymbol class="item-icon-center font-box item-icon-expand" :name="'lineheight'"></iconSymbol>
                <iconSymbol class="item-arrow" :name="'downArrow'"></iconSymbol>
            </div>
            <transition name="tabmodaltrans">
                <ul class="imgbox-list line-height-list" v-show="showFontLineHeight">
                    <li
                        class="imgbox-li"
                        :class="{ active: item.data == lineHeight }"
                        v-for="item in lineHeightList"
                        :key="item.id"
                        @click.stop="clickLineHeight(item.data)"
                    >
                        <p>{{ item.label }}</p>
                    </li>
                    <li class="hv-line"></li>
                    <li class="more-setting imgbox-li" @click="clickLineHeight(-1)">
                        <p>{{ $t("lineOption") }}</p>
                    </li>
                </ul>
            </transition>
        </div>
        <!-- <div
            class="font-btn expand-font-btn"
            :class="{ 'font-btn-active': showModal, 'navigation-ban-btn': !isSelect, activeFunc: activeFunc == 'tabsFontOption' }"
            :content="$t('tipsList.moreOption')"
            v-tippy="{ placement: 'bottom' }"
            @click="showFontModal()"
        >
            <iconSymbol class="item-icon-center item-icon-expand" :name="'fontT'"></iconSymbol>
            <iconSymbol class="item-arrow" :name="'downArrow'"></iconSymbol>
        </div> -->
        <NavigationDragBox
            :dragTitle="$t('dragTitle')"
            :originPostion="{ left: fontBoxOffsetLeft, top: '38px' }"
            :showModal="showModal"
            :lockBox="lockBox"
            :style="{ left: `${fontBoxOffsetLeft}px` }"
            @changeLock="changeLock($event)"
            @removeCloseEvent="removeEvent"
            @closeBox="closeModal"
        >
            <div class="editor-content" id="modal">
                <div
                    class="content-imgbox"
                    :class="{ active: strike, activeFunc: activeFunc == 'tabsDeleteLine' }"
                    :content="$t('tipsList.deleteLine')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="clickBtn('strikethrough')"
                >
                    <iconSymbol class="item-icon" name="delline"></iconSymbol>
                </div>

                <div class="content-imgbox" :class="{ 'ban-btn': isTextPath, activeFunc: activeFunc == 'tabsFontListStyle' }">
                    <div
                        id="liststylemodal"
                        class="liststylebox"
                        @click="showListStyleModal()"
                        :content="$t('tipsList.listStyle')"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol :class="{ active: selectFontEditor == 2 }" class="item-icon" name="liststyle"></iconSymbol>
                        <div class="liststylemodal" v-show="showListStyle">
                            <ul>
                                <li
                                    :class="{ active: item.id == listStyleActiveID }"
                                    v-for="item in listStyleList"
                                    :key="item.id"
                                    @click="clickListStyle(item.id)"
                                >
                                    <iconSymbol class="item-icon" :name="`${item.name}${isDarkTheme() ? '-dark' : ''}`"></iconSymbol>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="content-inputbox">
                    <div class="inputbox-line" @click="cancelRemind()">
                        <p class="inputbox-title">{{ $t("lineHeight") }}:</p>
                        <InputNumber
                            class="iview_input"
                            v-model="lineHeight"
                            size="small"
                            :min="0.8"
                            :max="9007199254740992"
                            :step="0.1"
                            :disabled="isTextPath"
                            :precision="1"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setFontMargin(0);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setFontMargin(0);
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="inputbox-line" @click="cancelRemind()">
                        <p class="inputbox-title">{{ $t("firstIndent") }}:</p>
                        <InputNumber
                            class="iview_input"
                            v-model="firstIndent"
                            size="small"
                            :min="0"
                            :max="maxIndent"
                            :step="1"
                            :disabled="isTextPath"
                            :formatter="(value) => `${Math.round(value * 10) / 10}${dynamicUnit}`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setFontMargin(1);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setFontMargin(1);
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="inputbox-line" @click="cancelRemind()">
                        <p class="inputbox-title">{{ $t("leftIndent") }}:</p>
                        <InputNumber
                            class="iview_input"
                            v-model="leftIndent"
                            size="small"
                            :min="0"
                            :max="maxIndent - rightIndent"
                            :step="1"
                            :disabled="isTextPath"
                            :formatter="(value) => `${Math.round(value * 10) / 10}${dynamicUnit}`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setFontMargin(2);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setFontMargin(2);
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="inputbox-line" @click="cancelRemind()">
                        <p class="inputbox-title">{{ $t("rightIndent") }}:</p>
                        <InputNumber
                            class="iview_input"
                            v-model="rightIndent"
                            size="small"
                            :min="0"
                            :max="maxIndent - leftIndent"
                            :step="1"
                            :disabled="isTextPath"
                            :formatter="(value) => `${Math.round(value * 10) / 10}${dynamicUnit}`"
                            :active-change="false"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setFontMargin(3);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setFontMargin(3);
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="inputbox-line" @click="cancelRemind()">
                        <p class="inputbox-title">{{ $t("before") }}:</p>
                        <InputNumber
                            class="iview_input"
                            v-model="before"
                            size="small"
                            :min="0"
                            :max="9007199254740992"
                            :step="1"
                            :disabled="isTextPath"
                            :formatter="(value) => `${Math.round(value * 10) / 10} pt`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setFontMargin(4);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setFontMargin(4);
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="inputbox-line" @click="cancelRemind()">
                        <p class="inputbox-title">{{ $t("after") }}:</p>
                        <InputNumber
                            class="iview_input"
                            v-model="after"
                            size="small"
                            :min="0"
                            :max="9007199254740992"
                            :step="1"
                            :disabled="isTextPath"
                            :formatter="(value) => `${Math.round(value * 10) / 10} pt`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setFontMargin(5);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setFontMargin(5);
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                </div>
            </div>
        </NavigationDragBox>
    </div>
</template>

<script lang="ts">
    declare var EDChart: any;
    declare var EDTable: any;
    declare var UnitUtil: any;
    declare var eUnit: any;
    import { Component, Prop, Vue, Watch, Inject, Mixins } from "vue-property-decorator";
    import NavigationDragBox from "./NavigationDragBox.vue";
    import fontTool from "@/app/mixin/fontTool";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            NavigationDragBox,
        },
    })
    export default class NavigationFont extends fontTool {
        @Inject()
        ["iviewInputBlur"];
        @Inject()
        ["showMessage"];
        lockInput: boolean = false;
        @Prop({ default: "normal" }) readonly type!: string;

        size: Array<string> = ["6", "7", "8", "9", "10", "11", "12", "14", "16", "18", "20", "22", "24", "26", "28", "36", "48", "72"];
        family: Array<string> = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "Microsoft YaHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "sans-serif",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
            "仿宋",
            "楷体",
            "隶书",
            "微软雅黑",
            "黑体",
            "宋体",
            "华文楷体",
            "华文行楷",
            "华文新魏",
        ];
        enFamily: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
        ];
        zhFamily: string[] = ["仿宋", "楷书", "隶书", "微软雅黑", "黑体", "宋体", "华文楷体", "华文行楷", "华文新魏"];

        lineHeightList: Array<{ id: number; label: string; data: number }> = [
            {
                id: 0,
                label: "1.0",
                data: 1.0,
            },
            {
                id: 1,
                label: "1.2",
                data: 1.2,
            },
            {
                id: 2,
                label: "1.5",
                data: 1.5,
            },
            {
                id: 3,
                label: "2.0",
                data: 2.0,
            },
            {
                id: 4,
                label: "2.5",
                data: 2.5,
            },
            {
                id: 5,
                label: "3.0",
                data: 3.0,
            },
        ];

        get activeRightPanelKey() {
            return this.$store.state.ui.activeRightPanelKey;
        }

        clickLineHeight(data) {
            this.showFontLineHeight = false;
            if (data == -1) {
                // 唤起顶部工具栏文本选项框
                if (this.activeRightPanelKey !== "shapeP") {
                    this.$bus.$emit("changeRightView", "shapeP", false, "other");
                }
                this.$store.commit("setStatus", {
                    type: "newActiveType",
                    data: this.fmtType.textSet,
                });
            } else {
                this.lineHeight = data;
                this.ft_setLineHeight(this.lineHeight);
            }
        }

        fontAlignHList: Array<{ id: number; text: string; name: string }> = [
            {
                id: 0,
                text: "",
                name: "centerleft",
            },
            {
                id: 1,
                text: "",
                name: "center",
            },
            {
                id: 2,
                text: "",
                name: "centerright",
            },
        ];
        fontAlignVList: Array<{ id: number; text: string; name: string }> = [
            {
                id: 0,
                text: "",
                name: "topaside",
            },
            {
                id: 1,
                text: "",
                name: "centeraside",
            },
            {
                id: 2,
                text: "",
                name: "bottomaside",
            },
        ];

        fontAroundList: Array<object> = [
            {
                id: 0,
                text: "",
                name: "fontaround1",
            },
            {
                id: 1,
                text: "",
                name: "fontaround2",
            },
            {
                id: 2,
                text: "",
                name: "fontaround3",
            },
            {
                id: 3,
                text: "",
                name: "fontaround4",
            },
            {
                id: 4,
                text: "",
                name: "fontaround5",
            },
            {
                id: 5,
                text: "",
                name: "fontaround6",
            },
            {
                id: 6,
                text: "",
                name: "fontaround7",
            },
            {
                id: 7,
                text: "",
                name: "fontaround8",
            },
            {
                id: 8,
                text: "",
                name: "fontaround9",
            },
            {
                id: 9,
                text: "",
                name: "fontaround10",
            },
            {
                id: 10,
                text: "",
                name: "fontaround11",
            },
            {
                id: 11,
                text: "",
                name: "fontaround12",
            },
            {
                id: 12,
                text: "",
                name: "fontaround13",
            },
            {
                id: 13,
                text: "",
                name: "fontaround14",
            },
            {
                id: 14,
                text: "",
                name: "fontaround15",
            },
        ];
        listStyleList: Array<object> = [
            {
                id: 0,
                text: "",
                name: "liststyle1",
            },
            {
                id: 1,
                text: "",
                name: "liststyle2",
            },
            {
                id: 2,
                text: "",
                name: "liststyle3",
            },
            {
                id: 3,
                text: "",
                name: "liststyle4",
            },
            {
                id: 4,
                text: "",
                name: "liststyle5",
            },
            {
                id: 5,
                text: "",
                name: "liststyle8",
            },
            {
                id: 6,
                text: "",
                name: "liststyle11",
            },
            {
                id: 7,
                text: "",
                name: "liststyle14",
            },
            {
                id: 8,
                text: "",
                name: "liststyle17",
            },
        ];
        showFamilyList: boolean = false;
        showSizeList: boolean = false;
        showFontAlign: boolean = false;
        showFontLineHeight: boolean = false;
        showMoreFontAlign: boolean = false;
        showFontAround: boolean = false;
        showListStyle: boolean = false;
        showModal: boolean = false;
        showbackgroundColor: boolean = false;
        familyName: string = "Arial";
        sizeName: string = "6";
        selectFontEditor: number = -1;
        fontEditorData: Array<number> = [1, 1, 1, 1, 1, 1];
        lockBox: boolean = false;
        oldFontSize: number = 0;
        fontBoxOffsetLeft: number = 415;
        fontBoxOffsetTimer: boolean = false;

        cancelRemind() {
            this.activeFunc = "";
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        setOldSize(e) {
            this.oldFontSize = e.target.value;
        }
        applyFontSize(size, isStep = false) {
            if (this.oldFontSize == size && !isStep)
                // 未更改值 切 非 +-操作，直接返回
                return;
            let status = this.ft_checkSizeOK(size);
            if (!status.status && status.code !== 0) {
                // fontsize超出限制，弹出提示
                let ts = this as any;
                // if (status.code == 0) {
                //     ts.showMessage({
                //         type: 2,
                //         content: ts.$t("msgContent") + status.data + ts.$t("msgContent2"),
                //     });

                // } else {
                // }
                ts.showMessage({
                    type: 2,
                    content: ts.$t("msgContent3") + status.data,
                });
                this.oldFontSize = size;
                this.applyFontSize(1000);
                return;
            }

            if (this.isEDChart) {
                this.ft_setChartSize(this.chartIndex, size);
            } else if (this.isEchart) {
                this.ft_setEchartFont({
                    fontSize: size,
                });
            } else if (this.isSelect) {
                this.ft_setSize(size - 0);
            } else {
                // 设置页面属性并记录到用户偏好
                this.changePageFont({
                    type: "size",
                    data: parseInt(size),
                });
            }
        }
        checkFontSize() {
            this.showSizeList = false;
            document.removeEventListener("click", this.closeSizeList);
            if (!this.isEchart) {
                this.applyFontSize(this.activedSize);
            }
        }
        // dragbox
        changeLock(flag) {
            this.$track("fixedbutton", "clickfixedbutton", "source: Text setting");
            this.lockBox = flag;
        }
        showFontModal() {
            this.activeFunc == "tabsFontOption" && this.cancelRemind();
            if (!this.isSelect) return;
            // this.sensors.track("clickEditPageButton", {
            //     Catalogues: "editPageButton",
            //     button_type: "clickTextSetting",
            // });
            if (this.showModal) {
                this.showModal = false;
                window.removeEventListener("click", this.closeModal0);
            } else {
                this.showModal = true;
                setTimeout(() => {
                    window.addEventListener("click", this.closeModal0);
                }, 0);
            }
        }
        closeModal() {
            // 点击x 关闭弹窗
            this.showModal = false;
        }
        removeEvent() {
            window.removeEventListener("click", this.closeModal0);
        }
        closeModal0(e) {
            // 点击空白处关闭弹窗
            let objTarget = document.getElementById(`modal`);
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                if (this.showbackgroundColor || this.showListStyle) {
                    this.showbackgroundColor = false;
                    return; // 选择文字背景色时不关闭弹窗
                }
                this.showModal = false;
                window.removeEventListener("click", this.closeModal0);
            }
        }
        // liststyle modal
        showListStyleModal() {
            this.cancelRemind();
            if (this.isTextPath) return;
            this.showListStyle = true;
            window.addEventListener("click", this.closeListStyle);
        }
        closeListStyle(e) {
            let objTarget = document.getElementById(`liststylemodal`);
            if (objTarget == null) {
                this.showListStyle = false;
                window.removeEventListener("click", this.closeListStyle);
                return;
            }
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                this.showListStyle = false;
                window.removeEventListener("click", this.closeListStyle);
            }
        }
        clickListStyle(index) {
            this.showListStyle = false;
            this.ft_setListStyle(index);
            this.$track("fastTool", "font bullet", index);
            window.removeEventListener("click", this.closeListStyle);
        }
        // around modal
        showAroundModal() {
            this.cancelRemind();
            if (!this.isSelect) return;
            // this.sensors.track("clickEditPageButton", {
            //     Catalogues: "editPageButton",
            //     button_type: "clickTextWrapping",
            // });
            this.showFontAround = true;
            window.addEventListener("click", this.closeAround);
        }
        closeAround(e) {
            let objTarget = document.getElementById(`aroundmodal`);
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                this.showFontAround = false;
                window.removeEventListener("click", this.closeAround);
            }
        }
        clickAround(index) {
            if (index == 15 && !this.isTextPath) return;
            this.showFontAround = false;
            this.ft_setTextPath(index);
            // window["_view"].editStyle("textOnPath", index);
            this.$track("fastTool", "font around", index);
            window.removeEventListener("click", this.closeAround);
        }
        // align Modal
        showAlignModal() {
            this.cancelRemind();
            // if(!this.isSelect) return;
            this.showFontAlign = !this.showFontAlign;
            window.addEventListener("click", this.closeAlign);
        }
        closeAlign(e) {
            // 点击空白处关闭弹窗
            let objTarget = document.getElementById(`alignmodal`);
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                this.showFontAlign = false;
                window.removeEventListener("click", this.closeAlign);
            }
        }
        // lineheight Modal
        showLineHeightModal() {
            this.cancelRemind();
            // if(!this.isSelect) return;
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickSpacing",
            });
            this.showFontLineHeight = !this.showFontLineHeight;
        }
        closeLineHeightModal() {
            this.showFontLineHeight = false;
        }
        clickAlign(type, i) {
            let alignText = [
                ["left", "top"],
                ["center", "top"],
                ["right", "top"],
                ["justify", "top"],
                ["left", "middle"],
                ["center", "middle"],
                ["right", "middle"],
                ["justify", "middle"],
                ["left", "bottom"],
                ["center", "bottom"],
                ["right", "bottom"],
                ["justify", "bottom"],
            ];
            // this.showFontAlign = false;
            this.selectFontEditor = -1;
            let v = type === "v" ? i : this.fontAlignVActiveID;
            let h = type === "h" ? i : this.fontAlignHActiveID;
            let index = this.getRealAlignId(v, h);

            if (this.isSelect) {
                this.ft_setAlign(index);
            } else {
                this.changePageFont({
                    type: "align",
                    data: index,
                });
            }

            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickAlignment",
            });
            this.$track("fastTool", "font align", alignText[index]);
            // window.removeEventListener("click", this.closeAlign);
        }
        startPreviewAlign(type, i) {
            let v = type === "v" ? i : this.fontAlignVActiveID;
            let h = type === "h" ? i : this.fontAlignHActiveID;
            let id = this.getRealAlignId(v, h);
            this.ft_previewAlign(id);
        }

        endPreview() {
            this.ft_endPreview();
        }
        clickFontImg(num) {
            this.selectFontEditor = num;
        }
        // font
        setFontMargin(type) {
            switch (type) {
                case 0: {
                    // LINE
                    this.ft_setLineHeight(this.lineHeight);
                    this.$track("fastTool", "font lineHeight", this.lineHeight);
                    break;
                }
                case 1: {
                    // FIRST IDENT
                    this.ft_setFirstIndent(this.firstIndent);
                    this.$track("fastTool", "font firstIndent", this.firstIndent);
                    break;
                }
                case 2: {
                    // LEFT IDENT
                    this.ft_setLeftIndent(this.leftIndent);
                    this.$track("fastTool", "font leftIndent", this.leftIndent);
                    break;
                }
                case 3: {
                    // RIGHT IDENT
                    this.ft_setRightIndent(this.rightIndent);
                    this.$track("fastTool", "font rightIndent", this.rightIndent);
                    break;
                }
                case 4: {
                    // BEFORE
                    this.ft_setBefore(this.before);
                    this.$track("fastTool", "font before", this.before);
                    break;
                }
                case 5: {
                    // AFTER
                    this.ft_setAfter(this.after);
                    this.$track("fastTool", "font after", this.after);
                    break;
                }
            }
        }

        clickFamilyName() {
            if (this.showFamilyList) {
                this.showFamilyList = false;
                document.removeEventListener("click", this.closeFamilyList);
            } else {
                this.showFamilyList = true;
                this.sensors.track("clickEditPageButton", {
                    Catalogues: "editPageButton",
                    button_type: "clickFont",
                });
                document.addEventListener("click", this.closeFamilyList);
            }
            // 打开列表时定位到当前选中字体
            this.$nextTick(() => {
                const dom = this.$refs.fontList as HTMLElement;
                let activeChild = dom.querySelector(".active") as HTMLElement;
                if (!activeChild) return;
                dom.scrollTop = activeChild.offsetTop - activeChild.offsetHeight * 2;
            });
        }
        clickSizeName() {
            if (this.showSizeList) {
                this.showSizeList = false;
                document.removeEventListener("click", this.closeSizeList);
            } else {
                this.oldFontSize = this.activedSize;
                this.showSizeList = true;
                this.sensors.track("clickEditPageButton", {
                    Catalogues: "editPageButton",
                    button_type: "clickFontSize",
                });
                document.addEventListener("click", this.closeSizeList);
                // const dom = document.querySelector('#sizeName input.font-name');
                // (<any>dom).focus()
            }
            // 打开列表时定位到当前选中字号
            this.$nextTick(() => {
                const dom = this.$refs.sizeList as HTMLElement;
                let activeChild = dom.querySelector(".active") as HTMLElement;
                if (!activeChild) return;
                dom.scrollTop = activeChild.offsetTop - activeChild.offsetHeight * 2;
            });
        }
        clickFamilyList(index) {
            this.showFamilyList = false;
            document.removeEventListener("click", this.closeFamilyList);
            this.$track("fastTool", "font family", this.family[index]);

            if (this.isEDChart) {
                this.ft_setChartFamily(this.chartIndex, this.family[index]);
            } else if (this.isEchart) {
                this.ft_setEchartFont({
                    fontFamily: this.family[index],
                });
            } else if (this.isSelect) {
                this.ft_setFamily(this.family[index]);
            } else {
                this.changePageFont({
                    type: "family",
                    data: this.family[index],
                });
            }
        }
        startFamilyPreview(name) {
            this.ft_previewName(name);
        }
        clickSizeList(index) {
            this.showSizeList = false;
            document.removeEventListener("click", this.closeSizeList);

            this.$track("fastTool", "font size", parseInt(this.size[index]));
            this.applyFontSize(this.size[index]);
        }
        startSizePreview(data) {
            this.ft_previewSize(data);
        }
        closeFamilyList(e) {
            let objTarget = document.getElementById(`familyName`);
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                this.showFamilyList = false;
                document.removeEventListener("click", this.closeFamilyList);
            }
        }
        closeSizeList(e) {
            let objTarget = document.getElementById(`sizeName`);
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                this.showSizeList = false;
                document.removeEventListener("click", this.closeSizeList);
            }
        }
        changeStepSize(type) {
            if (type == "-") {
                if ((<any>this).activedSize <= 0) {
                    return;
                }
                this.applyFontSize((<any>this).activedSize - 1, true);
            } else {
                if ((<any>this).activedSize == 72) {
                    return;
                }
                this.applyFontSize((<any>this).activedSize + 1, true);
            }
        }

        get fontColorWindow() {
            return this.$store.state.ui.fontColorWindow;
        }
        get fontbgColorWindow() {
            return this.$store.state.ui.fontbgColorWindow;
        }

        showFontColor(e) {
            this.cancelRemind();
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickTextColor",
            });
            // if(!this.isSelect) return;
            if (this.fontColorWindow) {
                return;
            }
            let node = e.target;
            let payload = {
                type: this.fmtType.font,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.commit("setStatus", {
                    type: "couldFixWindow",
                    data: true,
                });
                this.$store.commit("setStatus", {
                    type: "paletteShowAlpha",
                    data: false,
                });
                this.$store.dispatch("usePalette", { e, type: "fontColor" });
            });
        }
        showFontBackgoundColor(e) {
            this.cancelRemind();
            if (this.isTextPath || this.fontbgColorWindow) return;
            this.showbackgroundColor = true;
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickTextBgColor",
            });
            let node = e.target;
            let payload = {
                type: this.fmtType.font,
                index: 1,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.commit("setStatus", {
                    type: "couldFixWindow",
                    data: true,
                });
                this.$store.dispatch("usePalette", { e, type: "fontbgColor" });
            });
        }
        clickBtn(type: string) {
            this.cancelRemind();
            if (this.isEDChart) {
                switch (type) {
                    case "bold": {
                        let bold = this.$store.state.shape.fontFmt.bold;
                        this.ft_setChartBold(this.chartIndex, bold);
                        this.$track("fastTool", "chart bold", bold);
                        this.sensors.track("clickEditPageButton", {
                            Catalogues: "editPageButton",
                            button_type: "clickBold",
                        });
                        break;
                    }
                    case "italy": {
                        let italic = this.$store.state.shape.fontFmt.italic;
                        this.ft_setChartItalic(this.chartIndex, italic);
                        this.$track("fastTool", "chart italic", italic);
                        this.sensors.track("clickEditPageButton", {
                            Catalogues: "editPageButton",
                            button_type: "clickItalic",
                        });
                        break;
                    }
                    default: {
                        break;
                    }
                }
            } else if (this.isEchart) {
                switch (type) {
                    case "bold": {
                        this.ft_setEchartFont({
                            fontWeight: !this.bold ? "bold" : "normal",
                        });
                        break;
                    }
                    case "italy": {
                        this.ft_setEchartFont({
                            fontStyle: !this.italic ? "italic" : "normal",
                        });
                        break;
                    }
                    default: {
                        break;
                    }
                }
            } else {
                switch (type) {
                    case "bold": {
                        if (this.isSelect) {
                            this.ft_setBold(!this.bold);
                        } else {
                            this.changePageFont({
                                type,
                                data: !this.bold,
                            });
                        }
                        this.$track("fastTool", "font bold", !this.bold);
                        this.sensors.track("clickEditPageButton", {
                            Catalogues: "editPageButton",
                            button_type: "clickBold",
                        });
                        break;
                    }
                    case "italy": {
                        if (this.isSelect) {
                            this.ft_setItalic(!this.italic);
                        } else {
                            this.changePageFont({
                                type,
                                data: !this.italic,
                            });
                        }
                        this.$track("fastTool", "font italic", !this.italic);
                        this.sensors.track("clickEditPageButton", {
                            Catalogues: "editPageButton",
                            button_type: "clickItalic",
                        });
                        break;
                    }
                    case "underline": {
                        if (this.isSelect) {
                            this.ft_setUnderline(!this.underline);
                        } else {
                            this.changePageFont({
                                type,
                                data: !this.underline,
                            });
                        }
                        this.$track("fastTool", "font underline", !this.underline);
                        this.sensors.track("clickEditPageButton", {
                            Catalogues: "editPageButton",
                            button_type: "clickUnderscore",
                        });
                        break;
                    }
                    case "strikethrough": {
                        this.ft_setLineThrough(!this.strike);
                        this.$track("fastTool", "font strikethrough", !this.strike);
                        break;
                    }
                }
            }
        }
        submitToStore({ type, data }) {
            let obj = {
                type: "",
                data,
            };
            if (this.ignoreDefFont || !this.defaultFontType) {
                // 其他样式沿用主题
                let obj2 = {
                    type: "",
                    data,
                };
                obj2.type = "customDefaultFamily";
                obj2.data = this.$store.state.page.themeTextFamily;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultSize";
                obj2.data = this.$store.state.page.themeTextSize;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultBold";
                obj2.data = this.$store.state.page.themeTextBold;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultItalic";
                obj2.data = this.$store.state.page.themeTextItalic;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultUnderline";
                obj2.data = this.$store.state.page.themeTextUnderline;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultAlign";
                obj2.data = this.$store.state.page.themeTextAlign;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultFontColor";
                obj2.data = this.$store.state.page.themeTextColor;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultFontColorBg";
                obj2.data = "transparent";
                this.$store.commit("setStatus", obj2);
            }
            switch (type) {
                case "family": // 字体族
                    obj.type = "customDefaultFamily";
                    break;
                case "size": // 字号
                    obj.type = "customDefaultSize";
                    break;
                case "bold": // 加粗
                    obj.type = "customDefaultBold";
                    break;
                case "italy": // 斜体
                    obj.type = "customDefaultItalic";
                    break;
                case "underline": // 下划线
                    obj.type = "customDefaultUnderline";
                    break;
                case "align": // 对齐
                    obj.type = "customDefaultAlign";
                    break;
                case "color": // 颜色
                    obj.type = "customDefaultFontColor";
                    break;
            }
            this.$store.commit("setStatus", obj);
            this.$store.commit("setStatus", {
                type: "defaultFontType",
                data: 1,
            });
        }
        submitToView({ type, data }) {
            let view = window["_view"];
            if (view) {
                {
                    // 其他样式沿用主题
                    view.setUserDefaultStyle("customDefaultFamily", this.$store.state.ui.customDefaultFamily);
                    view.setUserDefaultStyle("customDefaultSize", this.$store.state.ui.customDefaultSize);
                    view.setUserDefaultStyle("customDefaultBold", this.$store.state.ui.customDefaultBold);
                    view.setUserDefaultStyle("customDefaultItalic", this.$store.state.ui.customDefaultItalic);
                    view.setUserDefaultStyle("customDefaultUnderline", this.$store.state.ui.customDefaultUnderline);
                    view.setUserDefaultStyle("customDefaultAlign", this.$store.state.ui.customDefaultAlign);
                    view.setUserDefaultStyle("customDefaultFontColor", this.$store.state.ui.customDefaultFontColor);
                    view.setUserDefaultStyle("customDefaultFontColorBg", this.$store.state.ui.customDefaultFontColorBg);
                }
                view.setUserDefaultStyle("defaultFontType", true);
                switch (type) {
                    case "family": // 字体族
                        view.setUserDefaultStyle("customDefaultFamily", data, true);
                        break;
                    case "size": // 字号
                        view.setUserDefaultStyle("customDefaultSize", data, true);
                        break;
                    case "bold": // 加粗
                        view.setUserDefaultStyle("customDefaultBold", data, true);
                        break;
                    case "italy": // 斜体
                        view.setUserDefaultStyle("customDefaultItalic", data, true);
                        break;
                    case "underline": // 下划线
                        view.setUserDefaultStyle("customDefaultUnderline", data, true);
                        break;
                    case "align": // 对齐
                        view.setUserDefaultStyle("customDefaultAlign", data, true);
                        break;
                    case "color": // 颜色
                        view.setUserDefaultStyle("customDefaultFontColor", data, true);
                        break;
                }
            }
        }
        submitToCloud({ type, data }) {
            let fontData = {
                defaultFontType: "1",
            };
            {
                Object.assign(fontData, { customDefaultFamily: this.$store.state.ui.customDefaultFamily });
                Object.assign(fontData, { customDefaultSize: this.$store.state.ui.customDefaultSize });
                Object.assign(fontData, { customDefaultBold: this.$store.state.ui.customDefaultBold });
                Object.assign(fontData, { customDefaultItalic: this.$store.state.ui.customDefaultItalic });
                Object.assign(fontData, { customDefaultUnderline: this.$store.state.ui.customDefaultUnderline });
                Object.assign(fontData, { customDefaultAlign: this.$store.state.ui.customDefaultAlign });
                Object.assign(fontData, { customDefaultFontColor: this.$store.state.ui.customDefaultFontColor });
                Object.assign(fontData, { customDefaultFontColorBg: this.$store.state.ui.customDefaultFontColorBg });
                this.ignoreDefFont = false;
            }
            switch (type) {
                case "family": // 字体族
                    Object.assign(fontData, {
                        customDefaultFamily: data,
                    });
                    break;
                case "size": // 字号
                    Object.assign(fontData, {
                        customDefaultSize: data,
                    });
                    break;
                case "bold": // 加粗
                    Object.assign(fontData, {
                        customDefaultBold: data,
                    });
                    break;
                case "italy": // 斜体
                    Object.assign(fontData, {
                        customDefaultItalic: data,
                    });
                    break;
                case "underline": // 下划线
                    Object.assign(fontData, {
                        customDefaultUnderline: data,
                    });
                    break;
                case "align": // 对齐
                    Object.assign(fontData, {
                        customDefaultAlign: data,
                    });
                    break;
                case "color": // 对齐
                    Object.assign(fontData, {
                        customDefaultFontColor: data,
                    });
                    break;
            }
            this.updateToCloud(fontData);
        }
        uploadTimer = 0;
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        updateToCloud(obj, type?) {
            if (this.uploadTimer) {
                clearTimeout(this.uploadTimer);
            }
            this.uploadTimer = setTimeout(() => {
                let data = this.customPreferContent || {};
                Object.assign(data, obj);
                this.customPreferContent = data;
                let jsonStr = JSON.stringify(data);
                let params = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    obj: { content: jsonStr },
                };
                if (this.userInfo)
                    this.$edApi.updateUserPrefer(params).then((e) => {
                        console.log(e);
                    });
            }, 500);
        }
        changePageFont(data) {
            this.submitToStore(data);
            this.submitToView(data);
            this.submitToCloud(data);
        }
        resizeTool() {
            //适应宽度
            if (this.fontBoxOffsetTimer) {
                return;
            }
            this.fontBoxOffsetTimer = true;
            setTimeout(() => {
                let windowW = window.innerWidth;
                this.fontBoxOffsetLeft = 415;
                if (windowW < 1194) {
                    this.fontBoxOffsetLeft = 15;
                }
                this.fontBoxOffsetTimer = false;
            }, 200);
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get isEDChart() {
            return window["_view"]._activeShape && window["_view"]._activeShape instanceof EDChart;
        }
        get chartIndex() {
            return this.$store.state.echart.index;
        }
        get isText() {
            return this.$store.state.shape.type === "TextBlock";
        }
        get isNormalType() {
            return this.type === "normal";
        }
        get dynamicUnit() {
            return this.$store.state.shape.fontFmt.dynamicUnit;
        }
        get maxIndent() {
            return this.$store.state.shape.fontFmt.maxIndent;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get isEchart() {
            return this.$store.state.shape.type == "EChartItem";
        }
        get echartOption() {
            if (!this.$store.state.newEchart.activeChartOption) return null;
            const option = JSON.parse(this.$store.state.newEchart.activeChartOption);
            return option.textStyle;
        }
        get fontColor() {
            let color = this.$store.state.shape.fontFmt.color;
            if (this.isEchart) color = this.echartOption?.color;
            else if (this.isSelect) color = this.$store.state.shape.fontFmt.color;
            else if (this.customSet && !this.ignoreDefFont) color = this.$store.state.ui.customDefaultFontColor;
            else color = this.$store.state.page.themeTextColor;
            if (color == null) {
                color = "#000";
            }
            return color;
        }
        get isTextPath() {
            return this.$store.state.shape.fontFmt.isTextPath;
        }
        get actived() {
            return this.$store.state.shape.fontFmt.actived;
        }
        get activedFamily() {
            // if (!this.actived) return '';
            if (this.isEchart) return this.echartOption?.fontFamily;
            else if (this.isSelect) return this.$store.state.shape.fontFmt.family || "";
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultFamily;
            else return this.$store.state.page.themeTextFamily;
        }
        get activedSize() {
            // if (!this.actived) return '';
            if (this.isEchart) return this.echartOption?.fontSize ? parseInt(this.echartOption.fontSize) : this.$store.state.page.themeTextSize;
            else if (this.isSelect) return this.$store.state.shape.fontFmt.size;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultSize;
            else return this.$store.state.page.themeTextSize;
        }
        set activedSize(v) {
            if (this.isEchart) {
                this.applyFontSize(v);
            } else if (this.isSelect) {
                let payload = {
                    type: "size",
                    data: v,
                };
                this.$store.commit("setFontFmtData", payload);
            } else {
                let obj = {
                    type: "customDefaultSize",
                    data: v,
                };
                this.$store.commit("setStatus", obj);

                this.changePageFont({
                    type: "size",
                    data: typeof v == "string" ? parseInt(v) : v,
                });
            }
        }
        get customSet() {
            return this.$store.state.ui.defaultFontType == 1;
        }
        get ignoreDefFont() {
            return this.$store.state.page.ignoreDefFont;
        }
        set ignoreDefFont(v) {
            let payload = {
                type: "ignoreDefFont",
                data: v,
            };
            this.$store.commit("setPageStat", payload);
        }
        get defaultFontType() {
            // font radio
            return this.$store.state.ui.defaultFontType || 0;
        }
        get bold() {
            // if (!this.actived) return false;
            if (this.isEchart) return this.echartOption?.fontWeight == "bold";
            else if (this.isSelect) return this.$store.state.shape.fontFmt.bold;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultBold;
            else return this.$store.state.page.themeTextBold;
        }
        get italic() {
            // if (!this.actived) return false;
            if (this.isEchart) return this.echartOption?.fontStyle == "italic";
            else if (this.isSelect) return this.$store.state.shape.fontFmt.italic;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultItalic;
            else return this.$store.state.page.themeTextItalic;
        }
        get underline() {
            // if (!this.actived) return false;
            if (this.isSelect) return this.$store.state.shape.fontFmt.underline;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultUnderline;
            else return this.$store.state.page.themeTextUnderline;
        }
        get strike() {
            if (!this.actived) return false;
            return this.$store.state.shape.fontFmt.strike;
        }
        get lineHeight() {
            if (!this.actived) return 1;
            return this.$store.state.shape.fontFmt.lineSpace;
        }
        get firstIndent() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.firstIndent;
        }
        get leftIndent() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.leftIndent;
        }
        get rightIndent() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.rightIndent;
        }
        get before() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.before;
        }
        get after() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.after;
        }
        set lineHeight(v) {
            this.$store.commit("setFontFmtData", {
                type: "lineSpace",
                data: v,
            });
        }
        set firstIndent(v) {
            this.$store.commit("setFontFmtData", {
                type: "firstIndent",
                data: v,
            });
        }
        set leftIndent(v) {
            this.$store.commit("setFontFmtData", {
                type: "leftIndent",
                data: v,
            });
        }
        set rightIndent(v) {
            this.$store.commit("setFontFmtData", {
                type: "rightIndent",
                data: v,
            });
        }
        set before(v) {
            this.$store.commit("setFontFmtData", {
                type: "before",
                data: v,
            });
        }
        set after(v) {
            this.$store.commit("setFontFmtData", {
                type: "after",
                data: v,
            });
        }
        get fontAlignActiveID() {
            if (this.isSelect) return this.$store.state.shape.fontFmt.align;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultAlign;
            else return this.$store.state.page.themeTextAlign;
        }

        get fontAlignVActiveID() {
            return this.getRenderAlignID(this.fontAlignActiveID).vAlign;
        }

        get fontAlignHActiveID() {
            return this.getRenderAlignID(this.fontAlignActiveID).hAlign;
        }

        get listStyleActiveID() {
            return this.$store.state.shape.fontFmt.bulletStyle;
        }
        get fontBackGroundColor() {
            return this.$store.state.shape.fontFmt.backClr;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        @Watch("lang")
        langChange(v) {
            if (v == "zh") {
                this.family = this.zhFamily.concat(this.enFamily);
            } else {
                this.family = this.enFamily.concat(this.zhFamily);
            }
        }

        mounted() {
            this.$nextTick(() => {
                this.resizeTool();
            });
            window.addEventListener("resize", this.resizeTool);
        }
        created() {
            let ts: any = this;
            ts.$bus.$on("openNavigationFontTool", (type: string) => {
                if (type == "align") {
                    this.showAlignModal();
                } else if (type == "around") {
                    this.showAroundModal();
                } else if (type == "option") {
                    this.showFontModal();
                } else if (type == "listStyle") {
                    this.showListStyleModal();
                }
            });
            ts.$bus.$on("changePageFont", (data) => {
                this.changePageFont(data);
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("openNavigationFontTool");
            ts.$bus.$off("changePageFont");
        }
    }
</script>
<i18n>
{
  "zh": {
    "showMoreFontAlign": "更多对齐方式",
    "dragTitle": "更多文本设置",
    "cleanAround": "清除路径",
    "lineHeight": "行间距",
    "firstIndent": "首行缩进",
    "leftIndent": "左侧缩进",
    "rightIndent": "右侧缩进",
    "before": "段前间距",
    "after": "段后间距",
    "msgContent": "当前浏览器最小字号为",
    "msgContent2": ",请选择其他字号或修改浏览器设置",
    "msgContent3": "最大字号为",
    "lineOption": "更多设置",
    "tipsList": {
      "bold": "加粗 Ctrl+B",
      "italy": "斜体 Ctrl+I",
      "underline": "下划线 Ctrl+U",
      "textColor": "文本颜色",
      "textAround": "文本在路径上",
      "textAlign": "对齐方式",
      "moreOption": "更多文本设置",
      "deleteLine": "删除线",
      "bgColor": "背景色",
      "listStyle": "列表样式",
      "centerleft": "左对齐",
        "center": "水平居中对齐",
        "centerright": "右对齐",
        "topaside": "顶部对齐",
        "centeraside": "垂直居中对齐",
        "bottomaside": "底部对齐"
    }
  },
  "en": {
    "showMoreFontAlign": "More Alignment",
    "dragTitle": "More Text Settings",
    "cleanAround": "None",
    "lineHeight": "Line Height",
    "firstIndent": "First Line",
    "leftIndent": "Left ",
    "rightIndent": "Right ",
    "before": "Before",
    "after": "After",
    "msgContent": "The minimum font size of the browser is",
    "msgContent2": ",Please select another font size or change the browser settings.",
    "msgContent3": "The Maximum Font Size is",
    "lineOption": "More Settings",
    "tipsList": {
      "bold": "Bold Ctrl+B",
      "italy": "Italic Ctrl+I",
      "underline": "Underline Ctrl+U",
      "textColor": "Font Color",
      "textAround": "Text on path",
      "textAlign": "Align",
      "moreOption": "More Options",
      "deleteLine": "Strikethrough ",
      "bgColor": "Text Highlight Color",
      "listStyle": "Bullets",
      "centerleft": "Left",
        "center": "Middle",
        "centerright": "Right",
        "topaside": "Top",
        "centeraside": "Center",
        "bottomaside": "Bottom"
    }
  },
  "fr": {
    "showMoreFontAlign": "Plus d'alignement",
    "dragTitle": "Plus de paramètres de texte",
    "cleanAround": "Chemin clair",
    "lineHeight": "Interligne",
    "firstIndent": "Retrait de première ligne",
    "leftIndent": "Retrait Gauche",
    "rightIndent": "Retrait Droite",
    "before": "Espacement Avant Paragraphe",
    "after": "Espacement Après Paragraphe",
    "msgContent": "La taille de police minimale du navigateur actuel est",
    "msgContent2": ", Veuillez choisir une autre taille de police ou modifier les paramètres de votre navigateur",
    "msgContent3": "Taille de police maximale est",
    "lineOption": "Plus de paramètres",
    "tipsList": {
      "bold": "Audacieux",
      "italy": "Italique",
      "underline": "Souligner",
      "textColor": "Couleur du texte",
      "textAround": "Texte sur un chemin",
      "textAlign": "Alignement",
      "moreOption": "Plus de paramètres",
      "deleteLine": "Barré",
      "bgColor": "Couleur de fond",
      "listStyle": "Style de liste",
      "centerleft": "Gauche",
        "center": "Milieu",
        "centerright": "Droite",
        "topaside": "Haut",
        "centeraside": "Centre",
        "bottomaside": "Bas"
    }
  },
  "de": {
    "showMoreFontAlign": "Weitere Ausrichtungsoptionen",
    "dragTitle": "Text-Einstellung",
    "cleanAround": "Nichts",
    "lineHeight": "Linienhöhe",
    "firstIndent": "Erstzeileneinzug",
    "leftIndent": "Linkseinzug",
    "rightIndent": "Rechtseinzug",
    "before": "Vorherabstand",
    "after": "Hintenabstand",
    "msgContent": "Die Mindestschriftgröße des Browsers beträgt",
    "msgContent2": "Bitte wählen Sie eine andere Schriftgröße oder ändern Sie die Browsereinstellungen.",
    "msgContent3": "Die maximale Schriftgröße beträgt",
    "lineOption": "Weitere Einstellungen",
    "tipsList": {
      "bold": "Fett Ctrl+B",
      "italy": "Kursiv Ctrl+I",
      "underline": "Unterstreichen Ctrl+U",
      "textColor": "Textfarbe",
      "textAround": "Text auf Pfad",
      "textAlign": "Ausrichten",
      "moreOption": "Weitere Optionen",
      "deleteLine": "Durchstrichen",
      "bgColor": "Hintergrundfarbe",
      "listStyle": "Listenformatvorlage",
      "centerleft": "Links",
        "center": "Mitte",
        "centerright": "Rechts",
        "topaside": "Oben",
        "centeraside": "Zentrum",
        "bottomaside": "Unten"
    }
  },
  "jp": {
    "showMoreFontAlign": "その他の配置",
    "dragTitle": "その他のオプション",
    "cleanAround": "パスをクリア",
    "lineHeight": "行間",
    "firstIndent": "最初の行のインデント",
    "leftIndent": "左のインデント",
    "rightIndent": "右のインデント",
    "before": "段落前の間隔",
    "after": "段落後の間隔",
    "msgContent": "ブラウザの最小フォントサイズは",
    "msgContent2": "、別のフォントサイズを選択するか、ブラウザの設定を変更してください",
    "msgContent3": "最大フォントサイズは",
    "lineOption": "詳細設定",
    "tipsList": {
      "bold": "太字",
      "italy": "斜体",
      "underline": "下線",
      "textColor": "テキストの色",
      "textAround": "テキストの並べ方",
      "textAlign": "揃え方",
      "moreOption": "その他のオプション",
      "deleteLine": "取り消し線",
      "bgColor": "テキストの背景色",
      "listStyle": "箇条書き",
      "centerleft": "左",
        "center": "中央",
        "centerright": "右",
        "topaside": "上",
        "centeraside": "中央",
        "bottomaside": "下"
    }
  },
  "es": {
    "showMoreFontAlign": "Más alineaciones",
    "dragTitle": "Más ajustes de texto",
    "cleanAround": "Ninguno",
    "lineHeight": "Altura de la línea",
    "firstIndent": "Primera línea",
    "leftIndent": "Izquierda",
    "rightIndent": "Derecho",
    "before": "Antes de",
    "after": "Después de",
    "msgContent": "El tamaño mínimo de la fuente del navegador es",
    "msgContent2": "Por favor, seleccione otro tamaño de fuente o cambie la configuración del navegador",
    "msgContent3": "El tamaño máximo de la fuente es",
    "lineOption": "Más ajustes",
    "tipsList": {
      "bold": "Negrita Ctrl+B",
      "italy": "Cursiva Ctrl+I",
      "underline": "Subraye Ctrl+U",
      "textColor": "Color de la fuente",
      "textAround": "Texto en Trazados",
      "textAlign": "Alinear",
      "moreOption": "Más opciones",
      "deleteLine": "Tachado",
      "bgColor": "Color de resalte del texto",
      "listStyle": "Balas",
      "centerleft": "Izquierda",
        "center": "Medio",
        "centerright": "Derecha",
        "topaside": "Arriba",
        "centeraside": "Centro",
        "bottomaside": "Inferior"
    }
  },
  "pt": {
    "showMoreFontAlign": "Mais opções de alinhamento",
    "dragTitle": "Mais Configurações de Texto",
    "cleanAround": "Nenhum",
    "lineHeight": "Altura da Linha",
    "firstIndent": "Primeira Linha",
    "leftIndent": "Esquerda",
    "rightIndent": "Direita",
    "before": "Antes",
    "after": "Depois",
    "msgContent": "O tamanho mínimo da fonte do browser é",
    "msgContent2": ",Por favor, selecionar outro tamanho de fonte ou alterar as configurações do browser.",
    "msgContent3": "O Tamanho Máximo da Fonte é",
    "lineOption": "Mais configurações",
    "tipsList": {
      "bold": "Negrito Ctrl+B",
      "italy": "Itálico Ctrl+I",
      "underline": "Sublinhar Ctrl+U",
      "textColor": "Cor da Fonte",
      "textAround": "Texto num caminho",
      "textAlign": "Alinhar",
      "moreOption": "Mais Opções",
      "deleteLine": "Riscado",
      "bgColor": "Cor do Destaque de Texto",
      "listStyle": "Balas",
      "centerleft": "Esquerda",
        "center": "Meio",
        "centerright": "Direita",
        "topaside": "Acima",
        "centeraside": "Centro",
        "bottomaside": "Abaixo"
    }
  },
  "it": {
    "showMoreFontAlign": "Altre opzioni di allineamento",
    "dragTitle": "Altre Impostazioni Testo",
    "cleanAround": "Nessuna",
    "lineHeight": "Altezza Linea",
    "firstIndent": "Prima Riga",
    "leftIndent": "Sinistro",
    "rightIndent": "Destro",
    "before": "Prima",
    "after": "Dopo",
    "msgContent": "La dimensione minima dei caratteri è",
    "msgContent2": ". Si prega di selezionare una dimensione diversa o di modificare le impostazioni del browser.",
    "msgContent3": "La Dimensione Massima dei caratteri è",
    "lineOption": "Altre impostazioni",
    "tipsList": {
      "bold": "Grassetto Ctrl+B",
      "italy": "Italico Ctrl+I",
      "underline": "Sottolineato Ctrl+U",
      "textColor": "Colore Carattere",
      "textAround": "Testo lungo tracciato",
      "textAlign": "Allinea",
      "moreOption": "Altre Opzioni",
      "deleteLine": "Barrato",
      "bgColor": "Colore di Evidenziazione",
      "listStyle": "Punti Elenco",
      "centerleft": "A sinistra",
        "center": "In mezzo",
        "centerright": "A destra",
        "topaside": "In alto",
        "centeraside": "Al centro",
        "bottomaside": "In basso"
    }
  },
  "tw": {
    "showMoreFontAlign": "更多對齊方式",
    "dragTitle": "更多文本設置",
    "cleanAround": "清除路徑",
    "lineHeight": "行間距",
    "firstIndent": "首行縮進",
    "leftIndent": "左側縮進",
    "rightIndent": "右側縮進",
    "before": "段前間距",
    "after": "段後間距",
    "msgContent": "當前瀏覽器最小字號為",
    "msgContent2": ",請選擇其他字號或修改瀏覽器設置",
    "msgContent3": "最大字號為",
    "tipsList": {
      "bold": "加粗 Ctrl+B",
      "italy": "斜體 Ctrl+I",
      "underline": "下劃線 Ctrl+U",
      "textColor": "文本顏色",
      "textAround": "線上文本",
      "textAlign": "對齊方式",
      "moreOption": "更多文本設置",
      "deleteLine": "刪除線",
      "bgColor": "背景色",
      "listStyle": "列表樣式",
      "topleft": "頂部左對齊",
      "topcenter": "頂部居中",
      "topright": "頂部右對齊",
      "topaside": "頂部兩端對齊",
      "centerleft": "居中左對齊",
      "center": "居中",
      "centerright": "居中右對齊",
      "centeraside": "居中兩端對齊",
      "bottomleft": "底部左對齊",
      "bottomcenter": "底部居中",
      "bottomright": "底部右對齊",
      "bottomaside": "底部兩端對齊"
    }
  },
  "kr": {
    "showMoreFontAlign": "추가 정렬",
    "dragTitle": "더 많은 텍스트 설정",
    "cleanAround": "경로 지우기",
    "lineHeight": "행간격",
    "firstIndent": "첫 줄 들여쓰기",
    "leftIndent": "왼쪽 들여쓰기",
    "rightIndent": "오른쪽 들여쓰기",
    "before": "단락 앞 간격",
    "after": "단락 뒤쪽 간격",
    "msgContent": "현재 브라우저의 최소 바이트는",
    "msgContent2": ", 다른 바이트를 선택하거나 브라우저 설정을 변경하세요",
    "msgContent3": "최대 크기는",
    "tipsList": {
      "bold": "굵기 Ctrl+B",
      "italy": "기울기 Ctrl+I",
      "underline": "밑줄 Ctrl+U",
      "textColor": "텍스트 색깔",
      "textAround": "텍스트",
      "textAlign": "정렬 방식",
      "moreOption": "더 많은 텍스트 설정",
      "deleteLine": "라인 삭제",
      "bgColor": "배경색",
      "listStyle": "목록 스타일",
      "topleft": "맨 위 왼쪽 정렬",
      "topcenter": "맨 위 가운데 정렬",
      "topright": "맨 위 오른쪽 정렬",
      "topaside": "맨 위 양단 정렬",
      "centerleft": "가운데서 왼쪽 정렬",
      "center": "가운데 정렬",
      "centerright": "가운데서 오른쪽 정렬",
      "centeraside": "가운데 양단 정렬",
      "bottomleft": "밑바닥 왼쪽 정렬",
      "bottomcenter": "밑바닥 가운데 정렬",
      "bottomright": "바닥 오른쪽 정렬",
      "bottomaside": "바닥 양단 정렬"
    }
  }
}
</i18n>
